<template>
    <div>
        <v-text-field label="Informe o endereço do link" v-model="link"></v-text-field>
    </div>
</template>

<script>
export default {
    props: [ 'value', 'current' ],
    data() {
        return {
            link: ''
        }
    },
    watch: {
        link() {
            this.$emit('input', this.link);
        }
    },
    created(){
        setTimeout(function(){
            if( this.$props.current && this.$props.current.type == 'custom' ) {
                this.link = this.$props.current.data;
            }
        }.bind(this), 500 );
    }
}
</script>